<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    label="グループ"
    itemName="name"
    :items="filteredItems"
    :management-office="managementOffice"
    :operation-offices="operationOffices"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getGroupResponse from '@/types/responses/getGroup';
import { onMounted, ref, watch, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = defineProps<{
  modelValue: getGroupResponse | undefined;
  managementOffice?: getManagementOffice | undefined;
  operationOffices?: getOperationOffice[] | undefined;
  type?: string | undefined;
  errorMessages?: string[];
}>();

const emit = defineEmits(['update:modelValue']);

const selectedItem = ref<getGroupResponse | undefined>(undefined);
const filteredItems = ref<getGroupResponse[]>([]);
const items = ref<getGroupResponse[]>([]);

onMounted(() => {
  Api()
    .autoCompleteGroups(makeQueryParams())
    .then((data) => {
      items.value = data;
      setFilterItems(data);
    });
});

function makeQueryParams() {
  return {
    status: 1
  };
}

const setFilterItems = (data: getGroupResponse[]) => {
  if (props.type === undefined) {
    filteredItems.value = data;
  } else {
    filteredItems.value = data.filter((item) => item.type === props.type);
  }
};

watch(
  () => props.type,
  () => {
    setFilterItems(items.value);
  }
);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
